import { PlatformSource } from '@/view-models/platform'

export const usePlatformStore = defineStore('platform', () => {
  const name = ref<PlatformSource>(PlatformSource.FunNow)
  const isAnonymousUser = ref(false)
  const isShowLoginStep = ref(false)
  /** for 打開 login modal 時，要不要跳過 landing 步驟 */
  const isTriggerLoginStep = computed(() => isAnonymousUser.value || isShowLoginStep.value)

  const isFunNowDomain = ref(false)
  /** only for FunBook V2 */
  const isFunBookV2 = computed(() => name.value === PlatformSource.FunBook)
  const isFunBookV2DomainCustomization = ref(false)
  const isFunBookV1Path = ref(false)
  const isFunBookV2Path = ref(false)

  const isNiceday = computed(() => name.value === PlatformSource.Niceday)

  function getBranchId() {
    /** tricky 作法 */
    const route = useRoute()
    return route.params.branch_id
  }

  return {
    name,
    isFunBookV2,
    getBranchId,
    isAnonymousUser,
    isShowLoginStep,
    isTriggerLoginStep,
    isFunBookV2DomainCustomization,
    isFunBookV1Path,
    isFunBookV2Path,
    isFunNowDomain,
    isNiceday,
  }
})
